import React from 'react';
import { useI18next } from 'gatsby-plugin-react-i18next';
import ActiveCampaignForm from '@components/ActiveCampaignForm';

import * as styles from './style.module.scss';

const { playSubscribe, playSubscribe__subscribeform } = styles;

const PlaySubscribe = ({
  formIdEN = 105,
  formIdDE = 107,
  formTitleEN = 'Subscribe to updates',
  formTitleDE = 'Jetzt für Updates anmelden',
}) => {
  const { language } = useI18next();

  const formId = language === 'en' ? formIdEN : formIdDE;

  return (
    <section className={`${playSubscribe}`}>
      <div className={`${playSubscribe__subscribeform}`}>
        <div className="active-campaign-form-container background-transparent in-content">
          <h4>{language === 'en' ? formTitleEN : formTitleDE}</h4>
          <ActiveCampaignForm formId={formId} />
        </div>
      </div>
    </section>
  );
};

export default PlaySubscribe;
